import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Occupant } from "@/livingInComponents/occupantOnboarding/acessCard";

export interface OccupantOnboardingState {
  selectedMember: Occupant | null;
}

const initialState: OccupantOnboardingState = {
  selectedMember: null,
};

const occupantOnboardingSlice = createSlice({
  name: "occupantOnboarding",
  initialState,
  reducers: {
    setSelectedMember: (state, action: PayloadAction<Occupant | null>) => {
      state.selectedMember = action.payload;
    },
    resetOccupantOnboarding: () => {
      return { ...initialState };
    },
  },
});

export const { setSelectedMember, resetOccupantOnboarding } =
  occupantOnboardingSlice.actions;
export default occupantOnboardingSlice.reducer;
